import { Routes, Route, Link } from 'react-router-dom';

import Assignment from './Assignment';

const Assignments = ({data}) => {

  /////////////////////////
  // render
  /////////////////////////
  return (
    <>
      <Routes>
        <Route path='/' element={
          <div className="flex flex-col mt-6 mx-8 space-y-6 md:tracking-wide">
            <div className="p-3 rounded bg-cod-gray-mid relative">
              {Object.entries(data).map(([key, value]) =>
                <Link
                  to={key}
                  key={key}
                  className="flex flex-row justify-between border border-transparent
                  bg-cod-gray p-3 my-1 w-full hover:border-current cursor-pointer" >
                  <div>{value.title}</div>
                  <div>{value.total} / {value.max_total} ({parseFloat(value.final).toFixed(2) * 100}%)</div>
                </Link>
              )}
            </div>
          </div>} />
        <Route path=':key' element={<Assignment data={data} />} />
      </Routes>
    </>
  );
};

export default Assignments;
